import React, { useState } from 'react'
import find from 'lodash/find'
import isEmpty from 'lodash/isEmpty'
import pickBy from 'lodash/pickBy'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { createPageTags } from 'supporticon/api/pages'
import { persistPageData } from '../../../../store/fundraisingPage'
import { selectPage, persistUserPageData } from '../../../../store/session'
import { selectAPIParams, selectButtonDefaults, selectTagDefinitions } from '../../../../store/site'
import { renderInput, renderFormFields } from 'supporticon/utils/form'
import { createPageMetadata } from '../../../../lib/metadata'
import { convertToString } from '../../../../lib/richText'
import { convertToMeters } from 'supporticon/utils/units'
import withForm from 'constructicon/with-form'
import form from './form'
import withStyles from 'constructicon/with-styles'
import styles from './styles'

import Form from 'constructicon/form'

const Tags = ({
  apiParams = {},
  customFields,
  customSupporterPage,
  form,
  fundraisingPage,
  onNext,
  persistPageData,
  persistUserPageData,
  tagDefinitions,
  buttonProps,
  styles,
  user
}) => {
  const [status, setStatus] = useState('empty')
  const { goalUom, showGoal } = customSupporterPage.fitness

  const handleSubmit = (e) => {
    e.preventDefault()

    return form.submit()
      .then(data =>
        Promise.resolve()
          .then(() => setStatus('fetching'))
          .then(() => {
            const tagValues = [
              showGoal && {
                tagDefinition: {
                  id: 'DSFitnessGoalTargetMeters',
                  label: 'Fitness Target'
                },
                value: convertToMeters(data.fitnessGoal, goalUom),
                aggregation: [{
                  segment: `page:campaign:${fundraisingPage.campaign}`,
                  measurementDomains: ['all']
                }]
              },
              ...tagDefinitions.map(tag => ({
                tagDefinition: {
                  id: tag.id,
                  label: tag.label
                },
                value: data[tag.id],
                aggregation: [{
                  segment: `page:campaign:${fundraisingPage.campaign}`,
                  measurementDomains: ['all'],
                  timeBox: {
                    notBefore: apiParams.startDateTime,
                    notAfter: apiParams.endDateTime
                  }
                }]
              })),
              ...customFields
                .filter(item => item.tag)
                .map(item => ({
                  tagDefinition: {
                    id: item.name,
                    label: item.tagLabel || convertToString(item.label).substring(0, 255)
                  },
                  value: data[item.name],
                  aggregation: [{
                    segment: `page:campaign:${fundraisingPage.campaign}`,
                    measurementDomains: ['all'],
                    timeBox: {
                      notBefore: apiParams.startDateTime,
                      notAfter: apiParams.endDateTime
                    }
                  }]
                }))
            ]
              .filter(Boolean)
              .filter(tag => tag.value)

            const metadata = pickBy(data, (_, key) => {
              const item = find(customFields, item => item.name === key)
              return item && !item.preventMds
            })

            return Promise.all([
              createPageTags({
                slug: fundraisingPage.slug,
                tagValues
              }),
              !isEmpty(metadata) && createPageMetadata({
                authType: user.authType,
                metadata,
                page: fundraisingPage.slug,
                token: user.token
              })
            ].filter(Boolean))
              .then(() =>
                Promise.resolve({
                  fitnessGoal: data.fitnessGoal,
                  tags: tagValues,
                  segmentation: {
                    ...fundraisingPage.segmentation,
                    ...data
                  }
                })
                  .then(pageData =>
                    Promise.all([
                      persistPageData(pageData),
                      persistUserPageData({
                        ...pageData,
                        metadata
                      })
                    ])
                  )
              )
          })
          .then(() => setStatus('fetched'))
          .then(() => onNext())
          .catch(error => {
            setStatus('failed')
            return Promise.reject(error)
          })
      )
  }

  const errors = status === 'failed'
    ? [{ message: 'There was an error updating your profile' }]
    : []

  return (
    <Form
      errors={errors}
      icon={false}
      isLoading={status === 'fetching'}
      noValidate
      onSubmit={handleSubmit}
      styles={styles.form}
      submit='Update'
      submitProps={buttonProps}>
      {renderFormFields(form.fields).map(field => {
        const InputTag = renderInput(field.type)

        return <InputTag key={field.name} {...field} />
      })}
    </Form>
  )
}

const mapState = (state, props) => ({
  ...selectAPIParams(state),
  buttonProps: selectButtonDefaults(state),
  tagDefinitions: selectTagDefinitions(state),
  userPage: selectPage(state)
})

const mapDispatch = { persistPageData, persistUserPageData }

export default compose(
  connect(mapState, mapDispatch),
  withStyles(styles),
  withForm(form)
)(Tags)
